<template>
    <LayoutBlock
    :tutorial_dialog="tutorial_dialog"
    v-on:closeDialog="handleCloseDialog"
    >
    <v-container class="ma-0 pa-0" v-if="measures">
        <v-row no-gutters>
            <v-radio-group class="pa-0 ma-0 d-flex flex-grow-1 flex-shrink-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                <v-radio label="Attivo" value="on"></v-radio>
                <v-radio label="Disattivo" value="off"></v-radio>
                <v-radio label="Fuori zona intervento" value="out"></v-radio>
            </v-radio-group>
        </v-row>
    <test
    :data="data.block.conf.test"
    ref="test"
    @updateMeasures="handleUpdateTest"
    @updateLinearity="handleAskUpdate"
    />
    <linearity
    v-if="testOK"
    :parent_res="measures.hi_res"
    :data="data.block.conf.linearity"
    ref="linearity"
    @updateMeasures="handleUpdateLinearity"
    @openRepDialog="handleOpenRep"
    />
    <div v-else>
        <div class="d-flex text-h5">Completare o verificare il test per la zavorra per accedere alla prova di linearità</div>
    </div>
    <div v-for="(singleRep,index) in measures.repPoints" :key="singleRep.block.measures.diff">
        <repeat
        :ref="'repeatability'+singleRep.block.measures.mass"
        :data="singleRep"
        :preview="true"
        />
    </div>
    </v-container>
    <ConfirmDialog 
        :data="confirmData"
        v-on:close_dialog="handleCloseDialog"
        v-on:confirm_result="handleConfirm"
    />
    <BaseDialog 
    :dialog="repDialog"
    :title="data.block.conf.repeatability.block.label"
    v-on:close_dialog="handleCloseDialog"
    :eager="true"
    >
        <repeat
        :data="data.block.conf.repeatability"
        :mass="curRep"
        ref="repFromDialog"
        />
        <div class="d-flex justify-center">
            <v-btn color="primary" @click="addRepPoint">Conferma misure</v-btn>
            <v-btn @click="handleCloseDialog">Annulla</v-btn>
        </div>
    </BaseDialog>
    </LayoutBlock>
</template>
<script>
import repeat from "../nawi_repeatability.vue"
import test from "../nawi_zavorra.vue"
import linearity from "./nawi_mechanical_linearity_zavorra.vue"
import LayoutBlock from "../../../../components/utils/LayoutBlock"
import BaseDialog from "../../../../components/dialogs/BaseDialog.vue"
import ConfirmDialog from "../../../../components/dialogs/ConfirmDialog.vue"
import {BaseLeg} from "../../../../utils/baseLeg"
export default {
    components: {test,linearity, LayoutBlock, ConfirmDialog, repeat, BaseDialog},
    mixins: [BaseLeg],
    data() {
        return {
            confirmData: {
                dialog: false,
                title: 'Valore test zavorra aggiornato',
                message: "Vuoi aggiornare i valori della linearità?",
                choices: [
                    {key: "cancel", val: "Mantieni precedenti", mod: "success"},
                    {key: "confirm", val: "Aggiorna"}
                    ]
            },
            repDialog: false,
            curRep: 0,
            testMass: null,
            loading: true
        }
    },
    // mounted(){
    //     if(this.data.block.measures){
    //         if(this.data.block.measures.test){
    //             this.$refs.test.setMeasures(this.data.block.measures.test)
    //         }
    //         if(this.data.block.measures.linearity){
    //             this.$refs.linearity.setMeasures(this.data.block.measures.linearity)
    //         }
    //     } else {
    //         console.log("$$ measures not found", this.measures, this.data.block.measures)
    //     }
    // },
    beforeMount() {
        console.log("$$ before mount implemented")
        this.beforeMountBuilder()
    },
    methods:{
        buildMeasures(){
            console.log("$$ inside test fusion block")
            this.measures =  {
                hi_res: this.data.block.conf.hi_res,
                zero_device: this.data.block.conf.zero_device,
                has_test: this.data.block.conf.has_test,
                result: 'uncomplete',
                test: null,
                linearity: null,
                repPoints: {}
            }
        },
        beforeMountBuilder() {
            console.log("$$ before Mount Builder Parent", this.data.block.conf)
            if(this.data){
                this.data.block.conf.test.common_data = this.data.common_data
                this.data.block.conf.test.instrument_data = this.data.instrument_data
                this.data.block.conf.test.primaries = this.data.primaries
                this.data.block.conf.linearity.common_data = this.data.common_data
                this.data.block.conf.linearity.instrument_data = this.data.instrument_data
                this.data.block.conf.linearity.primaries = this.data.primaries
                this.data.block.conf.repeatability.common_data = this.data.common_data
                this.data.block.conf.repeatability.instrument_data = this.data.instrument_data
                this.data.block.conf.repeatability.primaries = this.data.primaries
                if(this.data.block.measures){
                    console.log("$$ repPoints", this.data.block.measures.repPoints)
                    this.measures = this.data.block.measures
                    this.data.block.conf.test.block.measures = this.data.block.measures.test
                    this.data.block.conf.linearity.block.measures = this.data.block.measures.linearity
                } else {
                    this.loading = false
                    this.buildMeasures()
                }
            }
        },
        calcBlockResult(){
            if(this.measures.test && this.measures.linearity){
                let testR = this.measures.test.result
                let linR = this.measures.linearity.result
                let repR = this.getRepResult()
                if(testR == "uncomplete" || linR == "uncomplete" || repR == "uncomplete"){
                    this.measures.result = "uncomplete"
                } else if (testR == "failed" || linR == "failed" || repR == "failed"){
                    this.measures.result = "failed"
                } else if(testR == "done" && linR == "done" && repR == "done"){
                    this.measures.result = "done"
                } else {
                    this.measures.result = "uncomplete"
                }
            } else {
                this.measures.result = "uncomplete"
            }
        },
        handleResolution(){
            this.$refs.test.changeResolution(this.measures.hi_res)
            if(this.$refs.linearity){
                this.$refs.linearity.changeResolution(this.measures.hi_res)
            }
            if(this.$refs.repFromDialog){
                this.$refs.repFromDialog.changeResolution(this.measures.hi_res)
            }
            // not changing the others because they are photos taken in a certain moment
        },
        handleUpdateTest(data){
            if(!this.loading && this.testMass != data.measures.mass && data.measures.result == "done"){
                this.testMass = data.measures.mass
            this.confirmData.dialog = true
            }
            // console.log("$$ common mandati", data.common_data)
            // this.data.common_data = _.cloneDeep(data.common_data)
            this.measures.test = _.cloneDeep(data.measures)
        },
        handleUpdateLinearity(data){
            console.log("$$ linearity updated")
            this.measures.linearity = _.cloneDeep(data.measures)
            this.loading = false
        },
        handleCloseDialog(){
            this.tutorial_dialog.dialog = false
            this.confirmData.dialog = false
            this.repDialog = false
        },
        handleConfirm(data){
            console.log("$$ data received from dialog", data)
            if(data == "confirm"){
                this.$refs.linearity.buildRows(this.testMass)
                this.measures.repPoints = {}
            }
            this.handleCloseDialog()
        },
        async handleOpenRep(zavorra){
            console.log("$$ zavorra ricevuta", zavorra)
            this.repDialog = true
            await this.$refs.repFromDialog.buildMeasures()
            this.$refs.repFromDialog.measures.mass = zavorra
            this.$refs.repFromDialog.changeMass()
            this.$refs.repFromDialog.changeResolution(this.measures.hi_res)
        },
        addRepPoint(){
            let blocco = this.$refs.repFromDialog.measures
            let newRep = _.cloneDeep(this.data.block.conf.repeatability)
            newRep.block.measures = blocco
            this.measures.repPoints[blocco.mass] = newRep
            this.$refs.linearity.updateItemColor(blocco.mass, blocco.result)
            this.handleCloseDialog()
            this.saveMeasures()
        },
        handleAskUpdate(data){
            if(data.measures.result == "done"){
                this.testMass = data.measures.mass
                this.confirmData.dialog = true
            }
        }
    },
    computed:{
        testOK(){
            if (this.measures.test && this.measures.test.result == "done"){
                return true
            } else {
                return false
            }
        }
    }
}
</script>  